import SliderMobile from './SliderMobile';

const $ = jQuery;

export default class SwiperMobile extends SliderMobile {
    constructor(selector) {
        super(selector);
    }

    _addEventListener() {
        super._addEventListener();
    }

    _resizeCallback() {
        super._resizeCallback();

        if (this.isActive) {
            this._setBackgroundImageHeight();
        }
    }

    _initSlider() {
        this.isActive = true;
        let initialSlide = 1;

        if($(window).width() < 450) {
            initialSlide = 0;
        }

        this.isActive = true;

        $(this.selector).each((index, element)=>{
            //Possible TODO: Refactor originalSettings to get mobileSwiper work with their settings
            /*this.originalSettings.initialSlide = initialSlide;
            this.originalSettings.centeredSlides = true;
            this.originalSettings.lazyLoading = false;
            this.originalSettings.loop = false;
            this.originalSettings.slidersPerView = 'auto';
            this.originalSettings.onSetTranslate = (swiper, translate) => {
                swiper.container.find('.swiper-wrapper').css('transform', 'translate(' + translate + 'px, 0)');
            }*/
            this.mobileSlider.push(new Swiper (element, {
                containerModifierClass : this.originalSettings.containerModifierClass,
                wrapperClass : 'swiper__wrapper',
                slideClass : 'swiper__slide',
                slideActiveClass : 'slide--active',
                pagination: '.swiper__pagination',
                bulletClass : 'swiper__bullet',
                bulletActiveClass : 'bullet--active',
                paginationHiddenClass : 'pagination--hidden',
                paginationCurrentClass : 'pagination--current',
                paginationTotalClass : 'pagination__total',
                paginationProgressbarClass : 'pagination__progressbar',
                paginationClickableClass : 'pagination--clickable',
                paginationModifierClass : 'pagination--',
                buttonDisabledClass : 'pagination--disabled',
                slideNextClass : 'slide--next',
                slidePrevClass : 'slide--prev',
                centeredSlides: true,
                slidesPerView: 'auto',
                initialSlide: initialSlide,

                onSetTranslate: (swiper, translate) => {
                    swiper.container.find('.swiper-wrapper').css('transform', 'translate(' + translate + 'px, 0)');
                }
            }));
        });

        this._setBackgroundImageHeight();
    }

    _setBackgroundImageHeight() {
        let height = $('.features__swiper__container').outerHeight()
                     + 2 * parseInt($('.features__wrapper').css('padding-bottom'),10)
                     + $('.features').find('.swiper__pagination').height();
        $('.features__backgroundimage').height(height);
    }

    _destroySlider() {
        super._destroySlider();
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/SwiperMobile.js